window.addEventListener('DOMContentLoaded', () => {
  buildMenuTiles();

  const queryValue = getUrlQuery();

  if (queryValue === '') {
    const defaultType = document.querySelector('.js-default-type');
    getMatchingMenus(defaultType.dataset.type);
    setActiveNav(defaultType.dataset.type);
  } else {
    getMatchingMenus(queryValue);
    setActiveNav(queryValue);
  }
});

/*
  The side-by-side menus arrive from the metafield as a flat run of
  headings and lists (H3, UL, H3, UL...). Wrap each heading and the
  content that follows it into a tile so they can be laid out on a
  grid: a heading always sits at the top of its own tile, and a third
  section wraps onto a new row instead of spilling into a third column.
*/
function buildMenuTiles() {
  const HEADING = /^H[1-6]$/;

  document.querySelectorAll('.side-by-side-column').forEach((container) => {
    if (container.dataset.tiled) return;

    // Some blocks arrive wrapped in a bare <div> (Canary Wharf drinks, for
    // one), which would hide the headings from a direct-children check.
    // Walk down through any single-child wrappers to the element that
    // actually holds them.
    let host = container;
    while (
      host.children.length === 1 &&
      !HEADING.test(host.children[0].tagName) &&
      host.children[0].children.length
    ) {
      host = host.children[0];
    }

    const children = Array.from(host.children);
    const headingCount = children.filter((el) => HEADING.test(el.tagName)).length;

    // No headings, or only one: leave it as a single flowing list so a
    // long list still splits itself evenly across the two columns.
    if (headingCount < 2) return;

    const groups = [];
    children.forEach((el) => {
      if (HEADING.test(el.tagName) || groups.length === 0) groups.push([]);
      groups[groups.length - 1].push(el);
    });

    const fragment = document.createDocumentFragment();
    groups.forEach((nodes) => {
      const tile = document.createElement('div');
      tile.className = 'menu__tile';
      nodes.forEach((node) => tile.appendChild(node));
      fragment.appendChild(tile);
    });

    host.appendChild(fragment);
    host.classList.add('menu__tiles');
    container.dataset.tiled = 'true';
  });
}

function getUrlQuery() {
  // Read the param properly so ?type=lunch&utm_source=... still works.
  return new URLSearchParams(window.location.search).get('type') || '';
}

function getMatchingMenus(type) {
  let menus = document.querySelectorAll('.menu[data-type="' + type + '"');
  menus.forEach((menu) => {
    menu.classList.add('menu--active');
  });
}

function setActiveNav(type) {
  // A shared ?type=... link can name a menu this restaurant does not have
  // (e.g. lunch on a site that only serves it in some locations). Without
  // this guard querySelector returns null and the script throws.
  const link = document.querySelector('.menu-' + type);
  if (link) link.classList.add('page-navigation__link--active');
}